import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaintenancesService = {
    list: async (data) => axios.post(`${API_URL}/maintenances/list`, data).then(({ data }) => data.data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/maintenances/${id}`).then(({ data }) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(`${API_URL}/maintenances`, data).then(({data}) => data).catch((err) => { throw err }),
    update: async (id, data) => axios.post(`${API_URL}/maintenances/${id}`, data, {headers: { "Content-Type": "multipart/form-data" }}).then(({ data }) => data),
    delete: async (id) => axios.delete(`${API_URL}/maintenances/${id}`).then(({ data }) => data).catch((err) => { throw err }),
    reviewItems: async () => axios.get(`${API_URL}/maintenances/get/reviewItems`).then(({ data }) => data).catch((err) => { throw err }),
};

export default MaintenancesService;
